"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('services/deviceService',["require", "exports", "controllers/deviceControler", "routing/mainRouter", "models/userIdentityModel"], function (require, exports, deviceController, mainRouter, userIdentityModel) {
    "use strict";

    var DeviceService = function () {
        function DeviceService() {
            _classCallCheck(this, DeviceService);
        }

        _createClass(DeviceService, [{
            key: "getSerialNumbers",
            value: function getSerialNumbers(searchString) {
                return deviceController.getSerialNumbers({ searchString: searchString });
            }
        }, {
            key: "getImeis",
            value: function getImeis(searchString) {
                return deviceController.getImeis({ searchString: searchString });
            }
        }, {
            key: "getPhoneNumbers",
            value: function getPhoneNumbers(searchString) {
                return deviceController.getPhoneNumbers({ searchString: searchString });
            }
        }, {
            key: "getDeviceByBoxId",
            value: function getDeviceByBoxId(boxId) {
                return deviceController.getDeviceByBoxId({ boxId: boxId, environment: mainRouter.router.environmentId() });
            }
        }, {
            key: "getDeviceDetailsHistory",
            value: function getDeviceDetailsHistory(boxId, unitSerialNumber) {
                return deviceController.getDeviceDetailsHistory({ boxId: boxId, unitSerialNumber: unitSerialNumber });
            }
        }, {
            key: "getAllocations",
            value: function getAllocations(boxId, unitSerialNumber) {
                return deviceController.getAllocations({ boxId: boxId, unitSerialNumber: unitSerialNumber });
            }
        }, {
            key: "getAvailableOwners",
            value: function getAvailableOwners() {
                return deviceController.getAvailableOwners();
            }
        }, {
            key: "getAvailableLocations",
            value: function getAvailableLocations() {
                return deviceController.getAvailableLocations();
            }
        }, {
            key: "getAvailableEnvironments",
            value: function getAvailableEnvironments() {
                return deviceController.getAvailableEnvironments();
            }
        }, {
            key: "getAvailableStatuses",
            value: function getAvailableStatuses() {
                return deviceController.getAvailableStatuses();
            }
        }, {
            key: "getBatteryStatus",
            value: function getBatteryStatus(boxId, environmentId, created) {
                return deviceController.getBatteryStatus({ boxId: boxId, environment: environmentId, created: created });
            }
        }, {
            key: "getData",
            value: function getData(boxId, environmentId, limit, date) {
                return deviceController.getData({ boxId: boxId, environment: environmentId, limit: limit, date: date });
            }
        }, {
            key: "getDataForDate",
            value: function getDataForDate(boxId, unitSerialNumber, environmentId, date, reportParams) {
                return deviceController.getDataForDate({ boxId: boxId, unitSerialNumber: unitSerialNumber, environment: environmentId, date: date, params: reportParams });
            }
        }, {
            key: "getPacketsForDate",
            value: function getPacketsForDate(boxId, unitSerialNumber, environmentId, date, reportParams) {
                return deviceController.getPacketsForDate({ boxId: boxId, unitSerialNumber: unitSerialNumber, environment: environmentId, date: date, params: reportParams });
            }
        }, {
            key: "getRawPacketsForDate",
            value: function getRawPacketsForDate(boxId, unitSerialNumber, environmentId, date, reportParams) {
                return deviceController.getRawPacketsForDate({ boxId: boxId, unitSerialNumber: unitSerialNumber, environment: environmentId, date: date, params: reportParams });
            }
        }, {
            key: "getLatestPacket",
            value: function getLatestPacket(boxId, unitSerialNumber, environmentId, date, reportParams) {
                return deviceController.getLatestPacket({ boxId: boxId, unitSerialNumber: unitSerialNumber, environment: environmentId, date: date, params: reportParams });
            }
        }, {
            key: "getSosForDate",
            value: function getSosForDate(boxId, environmentId, date, reportParams) {
                return deviceController.getSosForDate({ boxId: boxId, environment: environmentId, date: date, params: reportParams });
            }
        }, {
            key: "getCommunicationsStatus",
            value: function getCommunicationsStatus(boxId, environmentId, created) {
                return deviceController.getCommunicationsStatus({ boxId: boxId, environment: environmentId, created: created });
            }
        }, {
            key: "hibernateDevice",
            value: function hibernateDevice(boxId, unitSerialNumber, environmentId) {
                return deviceController.hibernateDevice({ boxId: boxId, unitSerialNumber: unitSerialNumber, environment: environmentId });
            }
        }, {
            key: "wakeUpDevice",
            value: function wakeUpDevice(boxId, unitSerialNumber, environmentId) {
                return deviceController.wakeUpDevice({ boxId: boxId, unitSerialNumber: unitSerialNumber, environment: environmentId });
            }
        }, {
            key: "getHibernatedDevices",
            value: function getHibernatedDevices() {
                return deviceController.getHibernatedDevices();
            }
        }, {
            key: "getLastTimeFullyCharged",
            value: function getLastTimeFullyCharged(imei, environmentId, coverStartDate) {
                return deviceController.getLastTimeFullyCharged({ boxId: imei, environment: environmentId, coverStartDate: coverStartDate });
            }
        }, {
            key: "getLastTimeChargerInserted",
            value: function getLastTimeChargerInserted(imei, environmentId, coverStartDate) {
                return deviceController.getLastTimeChargerInserted({ boxId: imei, environment: environmentId, coverStartDate: coverStartDate });
            }
        }, {
            key: "getCurrentChargePercentage",
            value: function getCurrentChargePercentage(imei, environmentId, coverStartDate) {
                return deviceController.getCurrentChargePercentage({ boxId: imei, environment: environmentId, coverStartDate: coverStartDate });
            }
        }, {
            key: "updateDevice",
            value: function updateDevice(device, requesterTile) {
                return deviceController.updateDevice({ device: device, requesterTile: requesterTile });
            }
        }, {
            key: "updateDevices",
            value: function updateDevices(devices) {
                return deviceController.updateDevices({ devices: devices });
            }
        }, {
            key: "deserializePacket100",
            value: function deserializePacket100(imei, environment, partitionKeyDate, messageGuid, createdDate) {
                return deviceController.deserializePacket100({
                    imei: imei,
                    environment: environment,
                    partitionKeyDate: partitionKeyDate,
                    messageGuid: messageGuid,
                    createdDate: createdDate
                });
            }
        }, {
            key: "rebuildBatteryDataFromPolicyStart",
            value: function rebuildBatteryDataFromPolicyStart(brokerPolicyId, policyId, brokerPolicyHolderId, policyHolderFullName) {
                return deviceController.rebuildBatteryDataFromPolicyStart({
                    brokerPolicyId: brokerPolicyId,
                    policyId: policyId,
                    environment: mainRouter.router.environmentId(),
                    brokerPolicyHolderId: brokerPolicyHolderId,
                    policyHolderFullName: policyHolderFullName,
                    sessionId: userIdentityModel.sessionId()
                }) /*.fail((e) => { alert(e); })*/;
            }
        }]);

        return DeviceService;
    }();

    return new DeviceService();
});
//# sourceMappingURL=deviceService.js.map;
